// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from "react";

export const Desc = ({ size, fill, stroke }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill={fill || "none"}
      stroke={stroke}
      strokeWidth="2px"
    >
      <line x1="4" y1="28.97" x2="44" y2="28.97" />
      <line x1="4" y1="42.31" x2="24" y2="42.31" />
      <path d="M7.18,5.16h3.49c1.78,0,3.22,1.44,3.22,3.22v3.63c0,1.78-1.44,3.22-3.22,3.22h-3.49c-1.78,0-3.22-1.44-3.22-3.22v-3.63c.07-.37.13-.74.2-1.11.11-.3.33-.75.75-1.17.87-.86,1.98-.93,2.28-.94Z" />
      <path d="M9.9,21.13c-1.08-.7-2.55-1.85-3.77-3.6-1.16-1.67-2.16-3.71-2.17-5.17" />
      <path d="M21.24,5.16h3.49c1.78,0,3.22,1.44,3.22,3.22v3.63c0,1.78-1.44,3.22-3.22,3.22h-3.49c-1.78,0-3.22-1.44-3.22-3.22v-3.63c.07-.37.13-.74.2-1.11.11-.3.33-.75.75-1.17.87-.86,1.98-.93,2.28-.94Z" />
      <path d="M23.96,21.13c-1.08-.7-2.55-1.85-3.77-3.6-1.16-1.67-2.16-3.71-2.17-5.17" />
    </svg>
  );
};
